import context from '@truckdown/components-systems';
import { defineComponent, ref, Ref } from "vue";
import { ApiKeyModel, EditApiKeyModel, IApiKeyService } from '@truckdown/accounts';
import validationError from "../../Validation/Error/Error.vue";
import { showMessage } from '../../Utilities/Utilities';


interface IData {
    isLoading: Ref<boolean>,
    edit: Ref<EditApiKeyModel>,
    apiKey: Ref<ApiKeyModel>
};


const getInitialData = function (props: any) {
    var edit = {
        accountId: props.apiKey.accountId,
        name: props.apiKey.name,
        redirectUrl: props.apiKey.redirectUrl
    } as EditApiKeyModel;
    
    return {
        isLoading: ref<boolean>(false),
        edit: ref<EditApiKeyModel>(edit),
        apiKey: ref<ApiKeyModel>(props.apiKey)
    } as IData;
}

const getMethods = function(props: any, data: IData, ctx: any) {
    return {
        cancelClick: function (): void {
            ctx.emit(cancelEventName);
        },
        saveClick: async function (): Promise<void> {
            if (!data.isLoading.value) {
                data.isLoading.value = true;

                try {
                    let apiKeyService = await context.getService<IApiKeyService>('IApiKeyService');
                    var response = await apiKeyService.edit(props.apiKey.apiKey, data.edit.value);

                    if (!response || !response.ok) {
                        console.log("Error editing API Key: " + response.message);
                        showMessage("Error editint API Key.", "danger", true, true);
                    } else {
                        showMessage("API Key was successfully updated.", "success", true, true);
                        ctx.emit(updateEventName, response.data);
                    }
                } catch (err) {
                    console.log(err);
                } finally {
                    data.isLoading.value = false;
                }
            }
        }
    }
}

const updateEventName = 'update';
const cancelEventName = 'cancel';

export default defineComponent({
    props: {
        apiKey: {
            type: Object as () => ApiKeyModel,
            required: false
        }
    },
    components: {
        'error': validationError
    },
    emits: [updateEventName, cancelEventName],
    setup: function (props, ctx) {
        let data = getInitialData(props);
        let methods = getMethods(props, data, ctx);


        return {
            ...data,
            ...methods
        };
    }
});